<script setup>
import { computed } from 'vue'
import useDateTimeFormatter from '@/composables/useDateTimeFormatter.js'

/**
 * The date time formatter.
 */
const { formatDateTime } = useDateTimeFormatter()

/**
 * The component's inherited properties.
 */
const props = defineProps({
    /**
     * The current location of the load.
     *
     * @type {Object}
     */
    value: {
        type: Object,
        required: true,
    },
})

/**
 * The recorded at timestamp.
 *
 * @return {String}
 */
const recordedAt = computed(() => {
    return formatDateTime(props.value?.recorded_at)
})

/**
 * The data supplier.
 *
 * @return {String}
 */
const dataSupplier = computed(() => {
    return props.value?.data_supplier?.name
})
</script>

<template>
    <div>
        <span v-if="recordedAt" data-test="geo-timestamp-recorded-at">
            {{ recordedAt }}
        </span>
        <span v-if="dataSupplier" data-test="geo-timestamp-data-supplier">
            via {{ dataSupplier }}
        </span>
    </div>
</template>
